/**
 * The provider URL guard (mission 9 WP11 T066; FR-003, FR-007, FR-012; S22; contracts/ui-api.md
 * "Spine").
 *
 * A checkout, card-update or invoice URL comes from the API and is followed with a top-level
 * navigation, so a hostile or malformed value (a `javascript:` URL, a protocol-relative `//host`, a
 * path that climbs out of `/dev/stripe/`) must never reach `window.location.assign` or an `href`.
 * Until mission 12 adds https on the provider's hosts, the only acceptable form is the Stripe mock's
 * relative path: `/dev/stripe/` followed by path segments of letters, digits, `_` and `-`, with no
 * dot, backslash, percent escape, query or fragment. Anything else is an `UnsafeProviderUrlError`,
 * whose message is the register's `providerUnavailable` and never the URL (the URL is a capability:
 * it never reaches an Error, the DOM, state or a log).
 */
import { copyText } from './provisional-copy'

const MOCK_PATH = /^\/dev\/stripe(\/[A-Za-z0-9_-]+)+$/

/** A provider URL refused unfollowed; the screen renders `providerUnavailable` (S22). */
export class UnsafeProviderUrlError extends Error {
  constructor() {
    super(copyText('providerUnavailable'))
    this.name = 'UnsafeProviderUrlError'
  }
}

/** `url` when it is a relative `/dev/stripe/…` path; otherwise an `UnsafeProviderUrlError`. */
export function safeProviderUrl(url: string): string {
  if (!MOCK_PATH.test(url)) throw new UnsafeProviderUrlError()
  return url
}
